import { GlobalStates } from '../../mainv2/states/globalStates';
import { ViewportStateV3 } from './ViewportStateV3';
import { routingStore } from '../../common/stores/routing';
import { ModalState } from './ModalState';
import { experimentState } from '../../commonv2/states/globalStates';

export const GlobalStatesV3 = {
    currentUser: GlobalStates.currentUser,
    viewport: new ViewportStateV3(),
    modal: new ModalState(),
    routing: routingStore,
    experiments: experimentState,
};

window.addEventListener('resize', GlobalStatesV3.viewport.update);
